import React from "react";
import { VoiceBankStashProvider } from "src/hooks/useVoiceBankStash.js";

export const wrapRootElement = ({ element }) => (
  <VoiceBankStashProvider>{element}</VoiceBankStashProvider>
);
